<template>
  <v-container class="fill-height">
    <v-responsive>
      <v-card>
        <v-card-title>
          Disclaimer for {{ botName }}
        </v-card-title>
        <v-card-text >
          <p><strong>Data Collection and Use: </strong>
            By interacting with the
            {{ botName }}, you agree that we collect and store your questions and any information provided
            during the chat. This data is collected to provide and enhance our services, personalize your experience,
            and
            for internal analysis.
          </p>

          <p><strong>Data Security:</strong> We are committed to ensuring the security of your data. We implement a
            variety of security
            measures to maintain the safety of your personal information. However, no method of transmission over the
            Internet or method of electronic storage is 100% secure.
          </p>

          <p><strong>Data Sharing:</strong> We do not sell, trade, or otherwise transfer your personally identifiable
            information to outside
            parties without your consent. This does not include trusted third parties who assist us in operating our
            website, conducting our business, or servicing you, so long as those parties agree to keep this information
            confidential.
          </p>
          <p><strong>User Consent:</strong> By using
            {{ botName }}, you consent to our privacy policy. If you do not agree to our policy, please do
            not use our chatbot.</p>

          <p><strong>Changes to This Disclaimer:</strong> We may update this disclaimer from time to time. We will
            notify you of any changes
            by posting the new disclaimer on this page. These changes are effective immediately, after they are posted
            on this page.</p>
          <p><strong>Contact Us:</strong> If you have any questions about this disclaimer, please contact us at [Contact
            Information].</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" variant="outlined" block @click="consent()">I Consent</v-btn>
        </v-card-actions>
      </v-card>
    </v-responsive>
  </v-container>
</template>

<script>
export default {
  components: {},
  props:['botName'],
  mounted() {

  },
  methods:{
    consent(){
      console.log("Storing consent and going back to original request")
      localStorage.setItem("consented", "true");
      window.location = localStorage.getItem("savedFullPath");
    }
  }
};
</script>
